import Dialog from "components/dialog";
import Checkbox from "components/form/checkbox";
import Input from "components/form/input";

import * as problemReportsApi from "api/legacy_problem_reports";

import { track } from "utils/tracker";

import { useState } from "react";
import { useNotifications } from "hooks/notifications";

interface ProblemReportProps {
  questionId: number;
  onClose: () => void;
}

export default function ProblemReportDialog(
  props: ProblemReportProps
): JSX.Element {
  const { questionId, onClose } = props;

  const [loading, setLoading] = useState(false);
  const [showOther, setShowOther] = useState(false);
  const [formState, setFormState] = useState({
    noImage: false,
    wrongAnswer: false,
    grammar: false,
    other: false
  });
  const { setNotification } = useNotifications();

  const hasIndicatedProblem = Object.values(formState).find((value) => !!value);

  function reportProblem() {
    setLoading(true);
    problemReportsApi.create({ ...formState, questionId }).then(() => {
      setNotification({
        type: "success",
        title: "Problema reportado",
        text: "Obrigado por avisar!"
      });
      track("Reported problem");
      setLoading(false);
      onClose();
    });
  }

  function changeState(name, newValue) {
    setFormState((prevState) => {
      return { ...prevState, [name]: newValue };
    });
  }

  function handleOtherChange(newValue) {
    setShowOther(newValue);
    if (!newValue) changeState("description", null);
  }

  return (
    <Dialog
      title="Reportar problema"
      confirmText="Enviar"
      onCancel={onClose}
      onConfirm={reportProblem}
      disableConfirm={!hasIndicatedProblem}
    >
      <p className="dialog-text">
        Marque pelo menos uma opção que descreva o problema da questão
      </p>

      <div>
        <div className="mb-2">
          <Checkbox
            label="Faltando imagem"
            onChange={(newValue) => changeState("noImage", newValue)}
          />
        </div>
        <div className="mb-2">
          <Checkbox
            label="Resposta errada"
            onChange={(newValue) => changeState("wrongAnswer", newValue)}
          />
        </div>
        <div className="mb-2">
          <Checkbox
            label="Erro de gramática"
            onChange={(newValue) => changeState("grammar", newValue)}
          />
        </div>
        <div className="mb-3">
          <Checkbox label="Outro" onChange={handleOtherChange} />
        </div>

        {showOther && (
          <Input
            name="Outro"
            type="textarea"
            disabled={loading}
            validations={{ required: formState.other }}
            onChange={(newValue) => changeState("description", newValue)}
          />
        )}
      </div>
    </Dialog>
  );
}
